export default __webpack_public_path__ + "static/media/vid_lock.91174726.svg";